export const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());